const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];

export const niceBytes = x => {
  let l = 0,
    n = parseInt(x, 10) || 0;

  while (n >= 1000 && ++l) {
    n = n / 1000;
  }

  return n.toFixed(n < 10 && l > 0 ? 1 : 0) + units[l];
};
